/* Tooltips for bottom bar */
var selecteditems = [];

$(document).ready(function () {
  /* Detect when someone changes an input then update the closest "price" field with the new sum of quantity x price  also adds the bottom bar tooltips */
  $(".second-dpo-box").on("keyup paste input", "input, select", function () {
    /* make sure we update the subtotal */
    window.dpoOptions.updatePrice();
    window.dpoOptions.updateSku();

    /* make sure we're in a select input */
    if ($(this).is("select")) {
      /* get the selected item */
      var selectval = $(this).val();

      /* find the option text */
      var subprice = $(this)
        .find('option[value="' + selectval + '"]')
        .html();

      /* find the name of the row we're in */
      var rowname = $(this)
        .closest("td")
        .prev()
        .prev()
        .prev()
        .find("h3")
        .text();

      /* remove duplicates */
      selecteditems = selecteditems.filter(function (value, index, arr) {
        if (!value.startsWith(rowname)) {
          return value;
        }
      });

      /* checks for 0/qty, none, etc. */
      if (
        subprice != 0 &&
        subprice != "Qty" &&
        subprice != "No " &&
        subprice != "Non Scented "
      ) {
        /* remove extra spaces */
        subprice = subprice.replace("&nbsp;", " ").replace(/&nbsp;/g, "");

        /* get pricespan and update the text to be the new price */
        $(this)
          .closest("td")
          .next()
          .find(".pricespan")
          .text("$" + subprice.split("+")[1].substring(1));

        /* text formatting */
        if (rowname == "Add Scents" || rowname == "Complete Package") {
          selecteditems.push(rowname + " " + subprice);
        } else {
          selecteditems.push(rowname + " x" + subprice);
        }
      } else {
        /* reset pricespan */
        $(this).closest("td").next().find(".pricespan").text("$0.00");
      }
      /* apply tooltip */
      var length = selecteditems.length;
      if (length == 0) {
        /* no items are selected so display info text */
        $("#subtotalprice").attr("data-original-title", "No Items Selected");
      } else {
        /* build a list of items*/
        var sb = "<ul>";
        for (var i = 0; i < length; i++) {
          sb += "<li>" + selecteditems[i] + "</li>";
        }
        sb += "</ul>";
        $("#subtotalprice").attr("data-original-title", sb);
      }
    }
  });

  /* Change ribbon swatch color */
  $(document).on(
    "change",
    ".ribbon-select select, .bout-ribbon-select select",
    function () {
      var selectval = $(this).val();
      var colorname = $(this)
        .find('option[value="' + selectval + '"]')
        .text();
      colorname = colorname.substring(0, colorname.length - 1);
      $("#ribbon_swatch_color").css(
        "background-color",
        colormap.get(colorname)
      );
    }
  );

  $(document).on("change", ".band-select select", function () {
    var selectval = $(this).val();
    var imagesrc = "";
    if (selectval == "10001") {
      imagesrc =
        "https://cdn.shopify.com/s/files/1/0232/3591/9949/t/31/assets/dpo_custom_option_32980_pearlband.webp?v=1602668859";
      $("#band_type").css("background-image", "url(" + imagesrc + ")");
    } else if (selectval == "10002") {
      imagesrc =
        "https://cdn.shopify.com/s/files/1/0232/3591/9949/t/31/assets/dpo_custom_option_58977_rhinestone.webp?v=1602668865";
      $("#band_type").css("background-image", "url(" + imagesrc + ")");
    } else {
      $("#band_type").css("background-image", "none");
    }
  });

  /* when unloading, save the current form to localstorage for later */
  $(window).unload(function () {
    saveFormToLocalStorage();
  });

  /* Fade in/out the bototm bar (disabled right now)*/
  var bottombar = $(".floating-price");
  bottombar.css({ opacity: 1 });
  /*$(window).on('scroll', function() {
   		var st = $(this).scrollTop();
      	var h = $(document).height() / 6;
      	if(h > 500) h = 500;
      	bottombar.css({ 'opacity' : (st/h) - 0.2});
	});*/

  /* Load the product name into the powr iframes */
  $(".powr-form-builder iframe").load(function () {
    if ($(".powr-form-builder iframe").length > 0) {
      $(".powr-form-builder iframe")[0].contentWindow.postMessage(
        $("#product_title").text(),
        "https://www.powr.io"
      );
      $(".powr-form-builder iframe")[1].contentWindow.postMessage(
        $("#product_title").text(),
        "https://www.powr.io"
      );
    }
  });
});

/* Check product options/validation client-side (DPO does its own validation server side) */
function addToCartCheck(b1) {
  if ($("#ProductPrice").text().startsWith("$0.00")) {
    $("#zeromodal").modal("show");
    return;
  }

  var selec = $(".ribbon-select select").val();
  var productid = $("#ProductSelect-product-template-custom").val();
  var selec1 = $(".customcolor1 select").val();
  var selec2 = $(".customcolor2 select").val();
  var selec3 = $(".customcolor3 select").val();
  var selec4 = $(".customcolor4 select").val();
  var selec5 = $(".customcolor5 select").val();
  if (productid != null) {
    if (
      selec1 == "" &&
      selec2 == "" &&
      selec3 == "" &&
      selec4 == "" &&
      select5 == ""
    ) {
      $("#colormodal").modal("show");
      return;
    }
    if (selec != "") {
      var selected = $(".ribbon-select select")
        .find("option[value=" + selec + "]")
        .text();
      if (selected == "White ") {
        $("#ribbonmodal").modal("show");
        return;
      }
    }
  }

  if (selec != "") {
    var selected = $(".ribbon-select select")
      .find("option[value=" + selec + "]")
      .text();
    if (selected == "Just Like The Picture " || selected == "No Ribbons ") {
      $("#ribbonmodal").modal("show");
      return;
    }
  }
  window.dpoOptions.addToCart(this, event);
  $(b1).addClass("dpo-loading").attr({ disabled: "disabled" });
  setTimeout(() => {
    $(b1).removeClass("dpo-loading").attr({ disabled: false });
  }, 5000);
  pintrk('track', 'addtocart')
}

/* custom color selector */
function bindEventCustom() {
  $(document).on("change", "[class*=customcolor] select", function () {
    var selectval = $(this).val();
    var selector = "#customcolor1";
    if ($(this).parents(".customcolor2").length > 0) {
      selector = "#customcolor2";
    } else if ($(this).parents(".customcolor3").length > 0) {
      selector = "#customcolor3";
    } else if ($(this).parents(".customcolor4").length > 0) {
      selector = "#customcolor4";
    } else if ($(this).parents(".customcolor5").length > 0) {
      selector = "#customcolor5";
    }
    var colorname = $(this)
      .find('option[value="' + selectval + '"]')
      .text();
    colorname = colorname.substring(0, colorname.length - 1);
    setCustomColors(selector, colorname);
  });
}

/* scroll to element on page smoothly */
function scrollToOptions(selector) {
  $([document.documentElement, document.body]).animate(
    {
      scrollTop: $(selector).offset().top - 92,
    },
    1000
  );
}

/* Save serialized form data to localstorage */
function saveFormToLocalStorage() {
  if (typeof Storage !== "undefined") {
    var formdata = $('form[action="/cart/add"]').serialize();
    var productid = $("#product-id-hidden").text();
    if (productid == undefined)
      var productid = $("#ProductSelect-product-template-custom").val();
    if (productid == undefined)
      var productid = $("#ProductSelect-product-template-package").val();

    if (formdata != "" && productid != undefined) {
      localStorage.setItem(
        "formdata-" + productid,
        encodeURIComponent(formdata)
      );
    }
  }
}

function decodeData(data) {
  if (location.search.match("[Fd]")) {
    //Set ribbon swatch color from url
    var colorname = decodeURIComponent(getUrlVars()["F66"]);
    if (colorname === undefined) {
      colorname = "White";
    }
    colorname = colorname.replace("+", " ");
    $("#ribbon_swatch_color").css("background-color", colormap.get(colorname));

    var bandname = decodeURIComponent(getUrlVars()["F1"]);
    console.log("bandname: " + bandname);
    var imagesrc = "";
    if (bandname === "Pearl+Band") {
      imagesrc =
        "https://cdn.shopify.com/s/files/1/0232/3591/9949/t/31/assets/dpo_custom_option_32980_pearlband.webp?v=1602668859";
      $("#band_type").css("background-image", "url(" + imagesrc + ")");
    } else if (bandname === "Rhinestone+Band") {
      imagesrc =
        "https://cdn.shopify.com/s/files/1/0232/3591/9949/t/31/assets/dpo_custom_option_58977_rhinestone.webp?v=1602668865";
      $("#band_type").css("background-image", "url(" + imagesrc + ")");
    } else {
      $("#band_type").css("background-image", "none");
    }

    $(".second-dpo-box select").each(function (index, value) {
      var subprice = $(this)
        .find('option[value="' + $(this).val() + '"]')
        .html();
      var rowname = $(this)
        .closest("td")
        .prev()
        .prev()
        .prev()
        .find("h3")
        .text();

      if (
        subprice != null &&
        subprice != 0 &&
        subprice != "Qty" &&
        subprice != "Yes " &&
        subprice != "No " &&
        subprice != "Non Scented "
      ) {
        subprice = subprice.replace("&nbsp;", " ").replace(/&nbsp;/g, "");
        var parts = subprice.split("+");
        if (parts[1] != null) {
          $(this)
            .closest("td")
            .next()
            .find(".pricespan")
            .text("$" + parts[1].substring(1));
          if (rowname == "Add Scents" || rowname == "Complete Package") {
            selecteditems.push(rowname + " " + subprice);
          } else {
            selecteditems.push(rowname + " x" + subprice);
          }
        }
      } else {
        $(this).closest("td").next().find(".pricespan").text("$0.00");
      }
    });

    if (
      location.href.includes("choose-your-own-colors") ||
      location.href.includes("reception-kit")
    ) {
      if (location.href.includes("-calla-lily-")) {
        //Load custom color images/colors
        if (getUrlVars()["F9"] !== undefined && isNaN(getUrlVars()["F9"])) {
          setCustomColors(
            "#customcolor1",
            decodeURIComponent(getUrlVars()["F9"].replace("+", " "))
          );
          var colorSelector = $(".customcolor1 select");
          var selectedIndex = $(colorSelector).prop("selectedIndex") - 1;
          var imageSrc = $(colorSelector)
            .next()
            .find(".dpo_dd_list_preview > img")
            .eq(selectedIndex)
            .attr("src");
          console.log(selectedIndex);
          $(colorSelector)
            .closest("tr")
            .next()
            .find(".calla-lily-image")
            .css(
              "background",
              "url(" + imageSrc + ") no-repeat center center fixed"
            );
        }
        if (getUrlVars()["F23"] !== undefined && isNaN(getUrlVars()["F23"])) {
          setCustomColors(
            "#customcolor2",
            decodeURIComponent(getUrlVars()["F23"].replace("+", " "))
          );
        }
        if (getUrlVars()["F25"] !== undefined && isNaN(getUrlVars()["F25"])) {
          setCustomColors(
            "#customcolor3",
            decodeURIComponent(getUrlVars()["F25"].replace("+", " "))
          );
        }
        if (getUrlVars()["F26"] !== undefined && isNaN(getUrlVars()["F26"])) {
          setCustomColors(
            "#customcolor4",
            decodeURIComponent(getUrlVars()["F26"].replace("+", " "))
          );
        }
      } else if (location.href) {
        //.includes("copy")) {
        if (getUrlVars()["F9"] !== undefined && isNaN(getUrlVars()["F9"])) {
          setCustomColors(
            "#customcolor1",
            decodeURIComponent(getUrlVars()["F9"].replace("+", " "))
          );
        }
        if (getUrlVars()["F22"] !== undefined && isNaN(getUrlVars()["F22"])) {
          setCustomColors(
            "#customcolor2",
            decodeURIComponent(getUrlVars()["F22"].replace("+", " "))
          );
        }
        if (getUrlVars()["F23"] !== undefined && isNaN(getUrlVars()["F23"])) {
          setCustomColors(
            "#customcolor3",
            decodeURIComponent(getUrlVars()["F23"].replace("+", " "))
          );
        }
        if (getUrlVars()["F25"] !== undefined && isNaN(getUrlVars()["F25"])) {
          setCustomColors(
            "#customcolor4",
            decodeURIComponent(getUrlVars()["F25"].replace("+", " "))
          );
        }
        if (getUrlVars()["F26"] !== undefined && isNaN(getUrlVars()["F26"])) {
          setCustomColors(
            "#customcolor5",
            decodeURIComponent(getUrlVars()["F26"].replace("+", " "))
          );
        }
      } else {
        //Load custom color images/colors
        if (getUrlVars()["F9"] !== undefined && isNaN(getUrlVars()["F9"])) {
          setCustomColors(
            "#customcolor1",
            decodeURIComponent(getUrlVars()["F9"].replace("+", " "))
          );
        }
        if (getUrlVars()["F52"] !== undefined && isNaN(getUrlVars()["F52"])) {
          setCustomColors(
            "#customcolor2",
            decodeURIComponent(getUrlVars()["F52"].replace("+", " "))
          );
        }
        if (getUrlVars()["F53"] !== undefined && isNaN(getUrlVars()["F53"])) {
          setCustomColors(
            "#customcolor3",
            decodeURIComponent(getUrlVars()["F53"].replace("+", " "))
          );
        }
        if (getUrlVars()["F54"] !== undefined && isNaN(getUrlVars()["F54"])) {
          setCustomColors(
            "#customcolor4",
            decodeURIComponent(getUrlVars()["F54"].replace("+", " "))
          );
        }
        if (getUrlVars()["F23"] !== undefined && isNaN(getUrlVars()["F23"])) {
          setCustomColors(
            "#customcolor5",
            decodeURIComponent(getUrlVars()["F23"].replace("+", " "))
          );
        }
      }
    }
    return;
  }
  data = JSON.parse(
    '{"' +
      decodeURIComponent(data.replace(/&/g, '","').replace(/=/g, '":"')) +
      '"}',
    function (key, value) {
      return key === "" ? value : decodeURIComponent(value);
    }
  );
  //escape string so it doesnt break the parser when putting in special characters

  //convert data to json array
  //for each element, try to select name and then set the value
  //$('[name="' + option_name + '"]').val("' + option_value + '");
  $.each(data, function (option_name, option_value) {
    option_name = option_name.replace(/(:|\.|\[|\]|,|=|@)/g, "\\$1");
    option_value = option_value.replace(/(:|\.|\[|\]|,|=|@)/g, "\\$1");
    if (option_name == "form_type") {
      return true;
    }
    var input = $('[name="' + option_name + '"]');
    if (
      $(input).parents(".ribbon-select").length > 0 ||
      $(input).parents(".bout-ribbon-select").length > 0
    ) {
      var colorname = $(input)
        .find('option[value="' + option_value + '"]')
        .text();
      colorname = colorname.substring(0, colorname.length - 1);
      $("#ribbon_swatch_color").css(
        "background-color",
        colormap.get(colorname)
      );
    }
    if ($(input).parents("[class*=customcolor]").length > 0) {
      var selector = "#customcolor1";
      if ($(input).parents(".customcolor2").length > 0) {
        selector = "#customcolor2";
      } else if ($(input).parents(".customcolor3").length > 0) {
        selector = "#customcolor3";
      } else if ($(input).parents(".customcolor4").length > 0) {
        selector = "#customcolor4";
      } else if ($(input).parents(".customcolor5").length > 0) {
        selector = "#customcolor5";
      }

      var colorname = $(input)
        .find('option[value="' + option_value + '"]')
        .text();
      colorname = colorname.substring(0, colorname.length - 1);
      setCustomColors(selector, colorname);
    }
    $(input).val(option_value);

    if (
      input.is("select") &&
      option_name != "id" &&
      $(input).parents(".ribbon-select").length == 0 &&
      $(input).parents("[class*=customcolor]").length == 0
    ) {
      var selectval = option_value;
      var subprice = $(input)
        .find('option[value="' + selectval + '"]')
        .html();
      var rowname = $(input)
        .closest("td")
        .prev()
        .prev()
        .prev()
        .find("h3")
        .text();
      selecteditems = selecteditems.filter(function (value, index, arr) {
        if (!value.startsWith(rowname)) {
          return value;
        }
      });
      if (
        subprice != null &&
        subprice != 0 &&
        subprice != "Qty" &&
        subprice != "Yes " &&
        subprice != "No " &&
        subprice != "Non Scented "
      ) {
        subprice = subprice.replace("&nbsp;", " ").replace(/&nbsp;/g, "");
        var parts = subprice.split("+");
        if (parts[1] != null) {
          $(input)
            .closest("td")
            .next()
            .find(".pricespan")
            .text("$" + parts[1].substring(1));
          if (rowname == "Add Scents" || rowname == "Complete Package") {
            selecteditems.push(rowname + " " + subprice);
          } else {
            selecteditems.push(rowname + " x" + subprice);
          }
        }
      } else {
        $(input).closest("td").next().find(".pricespan").text("$0.00");
      }
    }
  });
  var length = selecteditems.length;
  if (length == 0) {
    $("#subtotalprice").attr("data-original-title", "No Items Selected");
  } else {
    var sb = "<ul>";
    for (var i = 0; i < length; i++) {
      sb += "<li>" + selecteditems[i] + "</li>";
    }
    sb += "</ul>";
    $("#subtotalprice").attr("data-original-title", sb);
  }

  window.dpoOptions.updatePrice();
  window.history.replaceState(null, null, window.location.pathname);
  //update again to fix customize text
  // setTimeout(function() {
  //$.each(data, function(option_name, option_value) {
  //$('[name="' + option_name + '"]').val(option_value);
  //});
  //}, 3000);
  //window.dpoOptions.updatePrice();
}

/* sets custom color palette colors */
function setCustomColors(selector, color) {
  if (color == "Mixed Foliage") {
    $(selector).css("background-color", "transparent");
    $(selector).css(
      "background",
      'url("https://cdn.shopify.com/s/files/1/0232/3591/9949/t/45/assets/dpo_custom_option_61760_dpo-custom-option-11142-swatch-mixedgreenery.jpg?v=1678558582") repeat'
    );
    $(selector).css("background-position", "35% 0%");
    $(selector).css("background-size", "40% 100%");
  } else if (color == "Silver Glitter") {
    $(selector).css("background-color", "transparent");
    $(selector).css(
      "background",
      'url("https://cdn.shopify.com/s/files/1/0232/3591/9949/files/SilverGlitter.jpg?v=1576276769") repeat'
    );
    $(selector).css("background-position", "35% 0%");
    $(selector).css("background-size", "40% 100%");
  } else if (color == "Gold Glitter") {
    $(selector).css("background-color", "transparent");
    $(selector).css(
      "background",
      'url("https://cdn.shopify.com/s/files/1/0232/3591/9949/files/GoldGlitter.jpg?v=1576276755") repeat'
    );
    $(selector).css("background-position", "35% 0%");
    $(selector).css("background-size", "40% 100%");
  } else if (color == "Light Greenery") {
    setCustomImage(selector, "65798_dpo-custom-option-38891-swatch-lightgreenery.jpg?v=1678558563");
  } else if (color == "Dark Greenery") {
    setCustomImage(selector, "24500_dpo-custom-option-25349-swatch-darkgreenery.jpg?v=1678558572");
  } else if (color == "Mixed Greenery") {
    setCustomImage(selector, "61760_dpo-custom-option-11142-swatch-mixedgreenery.jpg?v=1678558582");
  } else if (color == "Winter Greenery") {
    setCustomImage(selector, "88281_dpo-custom-option-64489-swatch-wintergreenery.jpg?v=1678558592");
  } else if (color == "Gold Foliage") {
    setCustomImage(selector, "84157_dpo-custom-option-57443-swatch-gold.jpg?v=1678558607");
  } else if (color == "Rose Gold Foliage") {
    setCustomImage(selector, "26800_dpo-custom-option-88466-swatch-rosegold.jpg?v=1678558614");
  } else if (color == "Silver Foliage") {
    setCustomImage(selector, "26624_dpo-custom-option-73442-swatch-silver.jpg?v=1678558601");
  } else if (color == "Sunflower") {
    setCustomImage(selector, "85918_dpo-custom-option-97222-swatch-sunflowers.jpg?v=1678558714");
  } else {
    $(selector).css("background", "none");
    $(selector).css("background-color", colormap.get(color.trim()));
  }
  if (color === "") {
    $(selector).css("background-color", "gray");
  }
}

/* set custom image */
function setCustomImage(selector, image_path) {
  let base_url =
    "https://cdn.shopify.com/s/files/1/0232/3591/9949/t/45/assets/dpo_custom_option_";
  $(selector).css("background-color", "transparent");
  $(selector).css("background", 'url("' + base_url + image_path + '") repeat');
  $(selector).css("background-position", "right top");
  $(selector).css("background-size", "155px 155px");
}

/* generates a link based on the serialized form data */
function createshare() {
  var formdata = $('form[action="/cart/add"]').serialize();
  //console.log(formdata);
  var url = window.location.href.split("?")[0];
  var shareurl;
  if (url.includes("?variant=")) {
    shareurl = url + "&" + encodeURIComponent(formdata);
  } else {
    shareurl = url + "?" + encodeURIComponent(formdata);
  }
  return shareurl;
}

/* https://html-online.com/articles/get-url-parameters-javascript/ */
function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(
    /[?&]+([^=&]+)=([^&]*)/gi,
    function (m, key, value) {
      vars[key] = value;
    }
  );
  return vars;
}
